import { render } from "./reduction_inside.vue?vue&type=template&id=55d7a73e"
import script from "./reduction_inside.vue?vue&type=script&lang=js"
export * from "./reduction_inside.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/reduction/inside/reduction_inside.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55d7a73e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55d7a73e', __exports__)) {
    console.log('reload')
    api.reload('55d7a73e', __exports__)
  }
  
  module.hot.accept("./reduction_inside.vue?vue&type=template&id=55d7a73e", () => {
    console.log('re-render')
    api.rerender('55d7a73e', render)
  })

}


export default __exports__